export const AUDIENCE_BUNDLES_INSIGHTS_REPORT_ID = 'audience-bundles-insights';
